<template>
  <BamLink v-for="(item, index) in list" :key="index" :to="item.route" class="link" :class="{ active: isActive(item, $route) }">
    {{ $t(item.name) }} <span v-if="item.amount">{{ item.amount }}</span>
  </BamLink>
</template>

<script setup>
import { BamLink } from 'bambam-router';

defineProps({
  list: {
    type: Array,
    default: null,
  },
});

const isActive = (item, route) => {
  if (item?.meta_name && route?.meta?.name) {
    const names = route.meta.name.split(' ');
    if (names.some((name) => item.meta_name === name)) {
      return true;
    }
  }
  return route.name === item?.route?.name;
};
</script>
